import { useLocation, useNavigate } from "react-router-dom";

import { BarraVoltar } from "@/components/sistema";

/**
 * A saída de toda tela que ainda não tem barra própria.
 *
 * O nome ficou por causa dos vinte e poucos lugares que importam este arquivo,
 * mas ele não flutua mais: era um círculo de 36px por cima do conteúdo, e
 * virou a BarraVoltar sticky do sistema. O motivo é duro — no PWA instalado
 * não existe gesto de voltar do navegador, então uma saída que rola para fora
 * da tela prende a pessoa, e o único caminho vira fechar o app.
 *
 * A lista de exceções é a mesma de antes, com um acréscimo: conforme cada
 * tela ganha a própria <BarraVoltar> com título, o caminho dela entra em
 * TEM_BARRA_PROPRIA para não nascerem duas barras.
 */
const SEM_VOLTAR = [
  "/", "/home", "/login", "/profile", "/recipes", "/admin", "/feedback",
  "/more", "/glucophoto",
];
const SEM_VOLTAR_PREFIXO = [
  "/recipes/", "/feedback/", "/glucophoto/",
  // estas também são a tela de receita, que monta a própria barra
  "/my-recipes/", "/clean-cakes/recipes/", "/clean-mornings/recipes/",
  // e as telas de bônus, que montam a própria BarraVoltar com título
  // (Clean Mornings, Clean Meals, Clean Cakes, Clean Bakes)
  "/clean-mornings/bonuses", "/clean-meals/bonuses", "/clean-cakes/bonuses", "/clean-bakes/bonuses",
];

/** Telas que já montam a própria BarraVoltar, com título. */
const TEM_BARRA_PROPRIA = [
  "/saved-recipes", "/support", "/shopping-list", "/clean-mornings/grocery-list", "/settings",
  "/daily-plan", "/weekly-plan", "/my-content", "/help", "/saved-remedies",
];

/**
 * Como TEM_BARRA_PROPRIA, mas por prefixo: `/support/:threadId` é uma tela por
 * conversa, e não dá para listar uma por uma.
 */
const TEM_BARRA_PROPRIA_PREFIXO = [
  "/support/",
  // remédio, Lista Enterrada e Como medir montam a própria barra com título;
  // a biblioteca (/clean-remedies, /la-botica) usa esta.
  "/clean-remedies/", "/la-botica/",
];

const FloatingBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const p = location.pathname;
  if (SEM_VOLTAR.includes(p)) return null;
  if (SEM_VOLTAR_PREFIXO.some((pre) => p.startsWith(pre))) return null;
  if (TEM_BARRA_PROPRIA.includes(p)) return null;
  if (TEM_BARRA_PROPRIA_PREFIXO.some((pre) => p.startsWith(pre))) return null;

  return (
    <BarraVoltar
      onVoltar={() => (window.history.length > 2 ? navigate(-1) : navigate("/"))}
    />
  );
};

export default FloatingBackButton;
